export const CleanUp_TYPE_REQUEST = "CleanUp_TYPE_REQUEST";
export const CleanUp_TYPE_SUCCESS = "CleanUp_TYPE_SUCCESS";
export const CleanUp_TYPE_FAILURE = "CleanUp_TYPE_FAILURE";

export const CleanUp_UPDATE_REQUEST = "CleanUp_UPDATE_REQUEST";
export const CleanUp_UPDATE_SUCCESS = "CleanUp_UPDATE_SUCCESS";
export const CleanUp_UPDATE_FAILURE = "CleanUp_UPDATE_FAILURE";
export const CleanUp_UPDATE_RESET = "CleanUp_UPDATE_RESET";
